export const filterDuplicateNumbers = (numbers: number[]) => {
  const uniqueNumbers = new Set(numbers)
  return Array.from(uniqueNumbers)
}
